import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const youCom = defineConnector({
  identifier: "youCom",
  name: "You.com",
  tagLine: "Web search and content retrieval for AI",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: () => "https://ydc-index\\.io/.*",
  auth: (app) => headerAuth([{ name: "X-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Create an API key in the [You.com platform](https://you.com/platform).",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://ydc-index.io/v1/search",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "test", count: 1 }),
    }),
  },
});
